import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './styles/SolarSim.css';
import SimContainer from './SimContainer';
import BeginStep from './steps/BeginStep';
import NotFound from './pages/NotFound';
import LocationStep from './steps/LocationStep';
import Stepper from './steps/Stepper';
import OrientationStep from './steps/OrientationStep';
import SurfaceStep from './steps/SurfaceStep';
import InfosStep from './steps/InfosStep';
import ResultStep from './steps/ResultStep';

const SolarSim = ({ initialProps }) => {
  return (
    <div className="solarsim">
      <BrowserRouter>
        <Routes>
          <Route path="/simulateur" element={<SimContainer />}>
            <Route index element={<Stepper step='begin'><BeginStep initialProps={initialProps} /></Stepper>} />
            <Route path="localisation" element={<Stepper step={0}><LocationStep /></Stepper>} />
            <Route path="orientation" element={<Stepper step={1}><OrientationStep /></Stepper>} />
            <Route path="surface" element={<Stepper step={2}><SurfaceStep /></Stepper>} />
            <Route path="informations" element={<Stepper step={3}><InfosStep /></Stepper>} />
            <Route path="resultats/:ruid?" element={<Stepper step={4}><ResultStep /></Stepper>} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default SolarSim;
